import React from 'react';
import { TwoLinesLabel } from 'components/common';
import UserStatusField from './UserStatusField';

import Box from '@material-ui/core/Box';
import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  labelWithGap: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  root: {
    padding: '8px 0',
  },
}));

const UserInfo = ({ user, showExtraDetails = false }) => {
  const classes = useStyles();

  if (!user?.id) {
    return null;
  }

  if (user.deletedAt) {
    return (
      <TwoLinesLabel
        small
        primary={
          <b style={{ color: '#FF0000' }}>{`${user.firstName} ${user.lastName} (deleted)`}</b>
        }
        secondary={<span style={{ color: '#FF0000' }}>{`${user.email}, ${user.phone}`}</span>}
      />
    );
  }

  const primary = (
    <Box className={classes.labelWithGap}>
      <b>{`${user.firstName} ${user.lastName}`}</b>
      <UserStatusField record={user} />
    </Box>
  );

  const secondary = (
    <Box>
      <Typography className={classes.labelWithGap}>
        <span>{user.email}</span>
        <span>{user.phone}</span>
      </Typography>

      {showExtraDetails && (
        <>
          <Typography>User ID: {user.id}</Typography>
          <Typography>Billing ID: {user.billingUserId}</Typography>
          <Typography>Cognito ID: {user.cognitoUserId}</Typography>
          <Typography>KYC Session ID: {user.kycSessionId ?? 'N/A'}</Typography>

          {!!user.singlePayerAccountNumber && (
            <Typography>UPS Single Payer Account: {user.singlePayerAccountNumber}</Typography>
          )}
        </>
      )}
    </Box>
  );

  return (
    <TwoLinesLabel
      autoSize
      classes={{ root: classes.root }}
      small
      primary={primary}
      secondary={secondary}
    />
  );
};

export default UserInfo;
